<template>
    <nav v-show="pageTotal">
        <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: pageIndex <= 1 }">
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="changeIndex(1)"
                    title="第一頁"
                    ><i class="las la-angle-double-left"></i
                ></a>
            </li>
            <li
                class="page-item"
                :class="{ disabled: pageIndex <= 1 }"
                v-show="!showEllipsis"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="changeIndex(pageIndex - 1)"
                    title="上一頁"
                    ><i class="las la-angle-left"></i
                ></a>
            </li>
            <li
                class="page-item"
                v-for="num in currentTotal"
                :key="num"
                :class="{ active: num === pageIndex }"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="changeIndex(num)"
                    >{{ ellipsisSymbol(num) }}</a
                >
            </li>

            <li
                class="page-item"
                :class="{ disabled: pageIndex >= pageTotal }"
                v-show="!showEllipsis"
            >
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="changeIndex(pageIndex + 1)"
                    title="下一頁"
                    ><i class="las la-angle-right"></i
                ></a>
            </li>
            <li class="page-item" :class="{ disabled: pageIndex >= pageTotal }">
                <a
                    class="page-link"
                    href="#"
                    @click.prevent="changeIndex(pageTotal)"
                    title="最後一頁"
                    ><i class="las la-angle-double-right"></i
                ></a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        pageTotal: {
            type: Number,
            require: true,
        },
        pageIndex: {
            type: Number,
            require: true,
        },
        paginationNum: {
            type: Number,
            default: 3,
        },
        showEllipsis: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        currentTotal() {
            let currentTotal = ['previous', 'next'];
            if (this.pageIndex === 1) {
                // 頭
                Array.from({
                    length: this.paginationNum,
                }).forEach((_, i) => currentTotal.splice(currentTotal.length - 1, 0, i + 1));

                currentTotal.splice(0, 1);
            } else if (this.pageTotal === this.pageIndex) {
                // 尾
                Array.from({
                    length: this.paginationNum,
                }).forEach((_, i) => currentTotal.splice(1, 0, this.pageTotal - i));
                currentTotal.splice(currentTotal.length - 1, 1);
            } else {
                // 中間
                const start = Math.floor((this.pageIndex - 1) / this.paginationNum)
                        * this.paginationNum
                    + 1;

                currentTotal = Array.from({ length: this.paginationNum }).map(
                    (_, i) => start + i,
                );
                if (this.showEllipsis) {
                    currentTotal = Array.from({
                        length: this.paginationNum,
                    }).map(
                        (_, i) => this.pageIndex
                            + i
                            - Math.floor(this.paginationNum / 2),
                    );
                }
                let addPrevious = false;
                let addNext = false;
                if (
                    currentTotal[currentTotal.length - 1] - this.paginationNum
                    > 1
                ) {
                    addPrevious = true;
                }
                if (currentTotal[0] + this.paginationNum < this.pageTotal) {
                    addNext = true;
                }
                if (addPrevious) {
                    currentTotal = ['previous', ...currentTotal];
                }
                if (addNext) {
                    currentTotal = [...currentTotal, 'next'];
                }
            }

            return currentTotal.filter(
                (num) => (num >= 1 && num <= this.pageTotal)
                    || ((num === 'next' || num === 'previous')
                        && this.showEllipsis),
            );
        },
    },
    methods: {
        changeIndex(val) {
            if (val === 'previous') {
                let index = this.pageIndex - this.paginationNum;
                index = index >= 1 ? index : 1;
                this.$emit('change-index', index);
                return;
            }
            if (val === 'next') {
                let index = this.pageIndex + this.paginationNum;
                index = index <= this.pageTotal ? index : this.pageTotal;
                this.$emit('change-index', index);
                return;
            }
            this.$emit('change-index', val);
        },
        ellipsisSymbol(val) {
            if (val === 'next' || val === 'previous') {
                return '...';
            }
            return val;
        },
    },
};
</script>

<style></style>
